export default __webpack_public_path__ + "static/media/utilityUpgrades.6f8d00a7.svg";